<template>
  <div :class="['page-wrapper', { 'tg-frame': isTGFrame }]">
    <div class="download-box">
      <!-- 顶部标题 -->
      <div v-if="!processId && !isTGFrame" class="header-title">
        <img class="logo" src="../../assets/images/entryThemeOne/logo-orange.png" />
      </div>
      <h1 :class="['main-title', { 'pd-top': !processId }]">
        <img src="../../assets/images/entryThemeOne/result-loan-user.png" alt="" />
      </h1>
      <!-- 主内容区域 -->
      <div class="main-content u-text-center">
        <div class="trapezoid">安全合规</div>
        <!-- 金额 -->
        <div class="auth-success">
          <p>最高可借额度(元)</p>
          <h2>200,000</h2>
        </div>

        <!-- 合规调整：移除夸大流程时效的宣传，仅保留一般提示。 -->
        <div class="credit-module bg-rotate">
          <div class="speed-channel">
            <div class="channel-info">
              <!-- 删除固定速度比例，仅保留速度提示和箭头标识。 -->
              <p class="speed-info">
                放款速度
                <span class="speed-icon">
                  <img src="../../assets/images/entryThemeOne/icon-up-arrow.png" alt="" />
                </span>
              </p>
            </div>
            <p class="speed-quotation">专享资格</p>
          </div>
        </div>

        <!-- 下载按钮 -->
        <van-button class="download-btn" type="default" @click="onUserDownloadClick">
          <img
            class="download-icon"
            src="../../assets/images/entryThemeOne/down-vector.png"
            alt=""
          />
          <!-- 下载操作改为用户主动触发，结果页不再自动倒计时跳转。 -->
          <span>下载APP 匹配更多资金</span>
        </van-button>
        <p class="download-tips">*页面额度仅供参考，实际下款金额以最终审批为准</p>
      </div>

      <!-- 温馨提示 -->
      <div class="tips-section">
        <p class="tips-text">
          温馨提示：未经您的明示许可，本平台不会对您的个人信息进行任何处理行为。请谨防第三方短信、电话诈骗，确保您的隐私与资金安全
        </p>
      </div>

      <!-- 3步完成借款 -->
      <div class="steps-section">
        <div class="steps-title">
          <img
            class="header-line left"
            src="../../assets/images/entryThemeOne/header-line.png"
            alt=""
          />
          <span class="steps-title-text">产品优势</span>
          <img class="header-line" src="../../assets/images/entryThemeOne/header-line.png" alt="" />
        </div>
        <div class="steps-container">
          <div class="step-item">
            <div class="step-icon">
              <img src="../../assets/images/entryThemeOne/step_2.png" alt="" />
            </div>
            <div class="step-text">灵活额度</div>
          </div>
          <div class="step-arrow">
            <img src="../../assets/images/entryThemeOne/step_arrow.png" alt="" />
          </div>
          <div class="step-item">
            <div class="step-icon">
              <img src="../../assets/images/entryThemeOne/step_3.png" alt="" />
            </div>
            <!-- 合规调整：使用中性流程名称，不承诺审批速度。 -->
            <div class="step-text">资料审核</div>
          </div>
          <div class="step-arrow">
            <img src="../../assets/images/entryThemeOne/step_arrow.png" alt="" />
          </div>
          <div class="step-item">
            <div class="step-icon">
              <img src="../../assets/images/entryThemeOne/step_4.png" alt="" />
            </div>
            <div class="step-text">安全保障</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as API_Common from '@/api/common.js'
import { isInTGFrame, navigateTGFrameOrSelf } from '@/utils/tgFrame'

export default {
  name: 'DownloadApp',
  data() {
    return {
      channel: this.$route.query.source, // 渠道标识
      brand: this.$route.query.brand, // 设备型号
      downAppUrl: undefined, // 下载地址
      processId: this.$route.query.processId || '', // 流程ID
    }
  },
  computed: {
    isAfter() {
      // 是否进件之后的是渠道半流程进件下载页
      if (this.$route.query.isAfter == 1 && this.$route.query.processId) {
        return true
      }
      return false
    },
    trackPvEvent() {
      if (!this.processId) return 100052
      return this.isAfter ? 100088 : 100086
    },
    isTGFrame() {
      return isInTGFrame()
    },
  },
  created() {
    window.__TRACK_SCENE_KEY__ = 'resultLoanThemeTwo'
  },
  mounted() {
    API_Common.handleBatchTrackBase(this.trackPvEvent)
    this.getDownloadUrl()
  },
  methods: {
    // 检查是否在微信中
    isWeixin() {
      var ua = navigator.userAgent.toLowerCase()
      return ua.indexOf('micromessenger') !== -1
    },

    // 下载按钮点击
    handleDownload() {
      let isWeixin = this.isWeixin()
      if (isWeixin) {
        this.showPop = true
      } else {
        const url =
          this.brand === 'xiaomi' ? 'https://app.xiaomi.com/detail/1500555' : this.downAppUrl
        navigateTGFrameOrSelf(url)
      }
    },
    onUserDownloadClick() {
      API_Common.handleBatchTrackBase(this.trackPvEvent + 1)
      this.handleDownload()
    },

    // 获取下载地址
    getDownloadUrl() {
      API_Common.getDownloadUrl(this.channel).then((res) => {
        if (res.code === 200) {
          this.downAppUrl = res.data.url
        } else {
          this.$toast.fail('获取下载地址失败,请重试')
        }
      })
    },
  },
  beforeDestroy() {
    window.__TRACK_SCENE_KEY__ = ''
  },
}
</script>

<style lang="scss" scoped>
.page-wrapper {
  min-height: 100vh;
}

.download-box {
  min-height: 100vh;
  background-image: url('../../assets/images/entryThemeOne/result-loan-bg.png');
  background-size: 100% 6rem;
  background-repeat: no-repeat;
  background-color: #f5f5f5;
  font-size: 0.24rem;
  padding: 0.1rem 0.3rem;

  // 顶部标题
  .header-title {
    padding: 0.3rem 0;

    .logo {
      width: 4rem;
      height: auto;
      margin-bottom: 0.16rem;
    }

    .title-text {
      font-size: 0.28rem;
      font-weight: 500;
      color: #333;
    }
  }

  // 主内容区域
  .main-title {
    &.pd-top {
      padding-top: 0.5rem;
    }
    font-size: 0.48rem;
    font-weight: 600;
    color: #333;
    margin-bottom: 0.6rem;
    text-align: center;
    img {
      width: 100%;
      height: auto;
    }
    .amount {
      color: #ff5713;
    }
  }
  .main-content {
    padding: 0.01rem 0.3rem 0.5rem;
    background: linear-gradient(180deg, #ffebdf 0%, #fffefd 21.48%, #fffdfc 100%);
    border: 1px solid #fff;
    border-radius: 0.16rem;
    box-shadow: 0 0.08rem 0.24rem rgba(0, 0, 0, 0.05);

    .credit-module {
      position: relative;
      border-radius: 0.24rem;
      margin-bottom: 0.2rem;
      background: #f9f9f9;
      padding: 0.28rem 0.2rem;
      &.bg-rotate {
        background: linear-gradient(135deg, #fff2eb 0%, #fff6f0 100%);
        border: 1px solid #ffe6d9;
      }

      .speed-channel {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0.15rem 0.2rem;

        .channel-info {
          flex: 1;

          .channel-title {
            font-size: 0.26rem;
            color: #601b00;
            margin-top: 0.08rem;
            margin-bottom: 0.18rem;
            text-align: left;
          }
          .speed-info {
            display: flex;
            align-items: center;
            font-size: 0.3rem;
            font-weight: 600;
            color: #601b00;
            text-align: left;
            .speed-icon {
              margin-left: 0.08rem;
            }
          }
        }

        .speed-quotation {
          position: absolute;
          top: 0rem;
          right: 0rem;
          font-size: 0.24rem;
          font-weight: 400;
          color: #fff;
          margin: 0;
          padding: 0.08rem 0.15rem;
          background-color: #ff6410;
          border-top-right-radius: 0.3rem;
          border-bottom-left-radius: 0.3rem;
          clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%, 0 50%);
        }
      }
    }

    // 圆角梯形
    .trapezoid {
      display: inline-block;
      position: relative;
      padding: 0.14rem 1rem;
      background: #ffba9160;
      color: #6c2e08;
      font-size: 0.28rem;
      font-weight: 500;
      margin-bottom: 0.4rem;
      border-radius: 0 0 0.6rem 0.6rem;

      // 使用clip-path创建圆角梯形效果
      clip-path: polygon(0% 0%, 100% 0%, 90% 100%, 10% 100%);

      // 调整文字样式
      text-align: center;
      line-height: 1.4;
      // box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }

    // 成功图标
    .success-icon {
      margin-bottom: 0.4rem;
      img {
        width: 1.4rem;
        height: auto;
      }
      .icon-circle {
        width: 1.2rem;
        height: 1.2rem;
        background: linear-gradient(135deg, #ff6b35 0%, #ff9e45 100%);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 auto;
      }
    }

    // 认证成功提示
    .auth-success {
      margin-bottom: 0.6rem;

      h2 {
        font-size: 0.8rem;
        font-weight: 600;
        color: #333;
        margin-bottom: 0.16rem;
      }

      p {
        font-size: 0.28rem;
        color: #666;
        margin-bottom: 0.5rem;
      }
    }

    // 福利卡片
    .benefit-cards {
      display: flex;
      justify-content: center;
      margin-bottom: 0.6rem;
      img {
        width: 6rem;
        height: auto;
      }
    }

    // 下载按钮
    .download-btn {
      width: 100%;
      height: 1rem;
      background: linear-gradient(135deg, #ff6b35 0%, #ff9e45 100%);
      border-radius: 0.5rem;
      font-size: 0.32rem;
      font-weight: 500;
      color: white;
      border: none;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 0.24rem;
      .download-icon {
        width: 0.32rem;
        height: auto;
      }
      span {
        margin-left: 0.12rem;
      }
    }

    .download-tips {
      font-size: 0.24rem;
      color: #999;
    }
  }

  // 温馨提示
  .tips-section {
    padding: 0.2rem;
    margin-bottom: 0.6rem;
    background: #fffbf9;
    border-radius: 0.24rem;
    margin: 0.3rem 0;
    .tips-text {
      font-size: 0.22rem;
      color: #75280b;
      line-height: 1.5;
      text-align: left;
    }
  }

  // 流程步骤
  .process-steps {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 0.4rem;

    .step-item {
      display: flex;
      flex-direction: column;
      align-items: center;

      .step-icon {
        width: 0.6rem;
        height: 0.6rem;
        background: linear-gradient(135deg, #ff6b35 0%, #ff9e45 100%);
        border-radius: 50%;
        color: white;
        font-size: 0.28rem;
        font-weight: 600;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 0.12rem;
      }

      .step-text {
        font-size: 0.22rem;
        color: #666;
      }
    }

    .step-arrow {
      margin: 0 0.1rem;
      color: #999;
    }
  }

  /* 3步完成借款 */
  .steps-section {
    background: linear-gradient(180deg, #fff9f6 0%, #ffffff 16.39%, #ffffff 100%);
    margin: 0.32rem 0;
    padding: 0.4rem;
    border-radius: 0.24rem;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);

    .steps-title {
      font-size: 0.32rem;
      font-weight: bold;
      text-align: center;
      margin-bottom: 0.32rem;
      color: #333;
      .header-line {
        width: 1rem;
        height: 0.1rem;
        margin-bottom: 0.15rem;
        &.left {
          transform: rotate(180deg);
        }
      }
      .steps-title-text {
        margin: 0 0.2rem;
      }
    }

    .steps-container {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .step-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        flex: 1;

        .step-icon {
          width: 0.7rem;
          height: 0.7rem;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 0.16rem;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .step-text {
          font-size: 0.2rem;
          font-weight: 600;
          color: #4b2209;
        }
      }

      .step-arrow {
        flex: 0.5;
        display: flex;
        justify-content: center;

        img {
          width: 0.7rem;
          height: 0.16rem;
          margin-bottom: 0.4rem;
        }
      }
    }
  }
}

.tg-frame .download-box {
  background: linear-gradient(180deg, #1fbf75 0%, #1fbf75 36%, #f3f4f6 36%, #f3f4f6 100%);
  background-image: none;
  background-color: #f3f4f6;
  color: #1a2744;

  .main-content {
    background: #fff;
    box-shadow: 0 0.08rem 0.24rem rgba(31, 191, 117, 0.12);

    .trapezoid {
      background: rgba(31, 191, 117, 0.25);
      color: #1a2744;
    }

    .auth-success {
      h2 {
        color: #1a2744;
      }

      p {
        color: #888;
      }
    }

    .credit-module {
      background: #f5fbf7;

      &.bg-rotate {
        background: linear-gradient(135deg, #edfbf3 0%, #e8f8ef 100%);
        border-color: #c8eed9;
      }

      .speed-channel {
        .channel-info {
          .channel-title {
            color: #1a2744;
          }

          .speed-info {
            color: #1a2744;
          }
        }

        .speed-quotation {
          background-color: #1fbf75;
        }
      }
    }

    .download-btn {
      background: linear-gradient(90deg, #ff8a45 0%, #ff5c1a 100%);
      box-shadow: 0 0.12rem 0.28rem rgba(255, 92, 26, 0.28);
    }

    .download-tips {
      color: #888;
    }
  }

  .tips-section {
    background: #f0faf4;

    .tips-text {
      color: #666;
    }
  }

  .steps-section {
    background: linear-gradient(180deg, #f5fbf7 0%, #ffffff 16.39%, #ffffff 100%);
    box-shadow: 0 2px 10px rgba(31, 191, 117, 0.08);

    .steps-title {
      color: #1a2744;
    }

    .steps-container {
      .step-item {
        .step-text {
          color: #666;
        }
      }
    }
  }
}
</style>
